(function () {
  console.log('[USO] Script booted');

  const GEOAPIFY_KEY = '7bedf8650ad84d0c82fe9f1b1fc35540';
  const SESSION_FLAG = 'geo-country-pop-seen';
  const REDIRECT_URL = 'https://eatmisfits.com';

  console.log('[USO] Config loaded', {
    SESSION_FLAG,
    REDIRECT_URL
  });

  fetch(`https://api.geoapify.com/v1/ipinfo?apiKey=${GEOAPIFY_KEY}`)
    .then(res => {
      console.log('[USO] Fetch response received', res);

      if (!res.ok) {
        console.error('[USO] Fetch response NOT OK', {
          status: res.status,
          statusText: res.statusText
        });
      }

      return res.json();
    })
    .then(json => {
      console.log('[USO] Full Geoapify response:', json);

      const countryName = json?.country?.names?.en || '';
      const iso = (json?.country?.iso_code || '').toUpperCase();

      console.log('[USO] Parsed geo data:', {
        iso,
        countryName
      });

      console.log('[USO] Session flag exists?', sessionStorage.getItem(SESSION_FLAG));

      window.fsAttributes = window.fsAttributes || [];

      console.log('[USO] fsAttributes state:', window.fsAttributes);

      window.fsAttributes.push([
        'cmsfilter',
        () => {
          console.log('[USO] cmsfilter callback fired');
          matchCountry(countryName, iso);
        }
      ]);

      const shouldShow =
        (iso === 'US' || iso === 'CA') &&
        !sessionStorage.getItem(SESSION_FLAG);

      console.log('[USO] Popup decision:', {
        iso,
        shouldShow
      });

      if (shouldShow) {
        console.log('[USO] Showing popup NOW');

        try {
          showCountryPopup(iso, countryName);

          console.log('[USO] Popup function completed');

          sessionStorage.setItem(SESSION_FLAG, '1');

          console.log('[USO] Session flag set');
        } catch (err) {
          console.error('[USO] Popup crashed:', err);
        }
      } else {
        console.log('[USO] Popup skipped');
      }
    })
    .catch(err => {
      console.error('[USO] Geo lookup failed HARD:', err);
    });

  function normalize(s) {
    return String(s || '').trim().toLowerCase();
  }

  function matchCountry(name, iso) {
    console.log('[USO] matchCountry() called', {
      name,
      iso
    });

    const select = document.getElementById('Country');

    console.log('[USO] Country select found?', !!select);

    if (!select) {
      console.warn('[USO] No #Country select exists');
      return;
    }

    console.log('[USO] Select options count:', select.options.length);

    let match = Array.from(select.options).find(o =>
      (o.value || '').toUpperCase() === iso ||
      (o.dataset.iso || '').toUpperCase() === iso
    );

    console.log('[USO] ISO match result:', match);

    if (!match) {
      const wanted = normalize(name);

      console.log('[USO] Attempting fallback text match:', wanted);

      match = Array.from(select.options).find(o =>
        normalize(o.value) === wanted ||
        normalize(o.textContent) === wanted
      );
    }

    if (!match) {
      console.warn('[USO] No country match found', {
        iso,
        name
      });

      console.log(
        '[USO] Available options:',
        Array.from(select.options).map(o => ({
          value: o.value,
          text: o.textContent
        }))
      );

      return;
    }

    console.log('[USO] Final matched option:', {
      value: match.value,
      text: match.textContent
    });

    select.value = match.value;

    console.log('[USO] Select value set:', select.value);

    select.dispatchEvent(new Event('input', { bubbles: true }));
    select.dispatchEvent(new Event('change', { bubbles: true }));

    console.log('[USO] Input/change events dispatched');

    const params = new URLSearchParams(location.search);

    console.log('[USO] Existing URL params:', params.toString());

    if (!params.has('country')) {
      params.set('country', match.value);

      const newUrl =
        `${location.pathname}?${params.toString()}${location.hash}`;

      console.log('[USO] Updating URL:', newUrl);

      history.replaceState({}, '', newUrl);
    }
  }

  function showCountryPopup(iso, name) {
    console.log('[USO] showCountryPopup() entered');

    const msg =
      iso === 'US'
        ? 'Hey! You appear to be visiting from the United States or Canada.'
        : 'Hey! You appear to not be in the United Kingdom.';

    console.log('[USO] Popup message:', msg);

    const existing = document.querySelector('[data-country-pop]');

    console.log('[USO] Existing popup already in DOM?', !!existing);

    const root = document.createElement('div');

    root.setAttribute('data-country-pop', '');
    root.setAttribute('role', 'dialog');

    console.log('[USO] Root created:', root);

    root.innerHTML = `
        <div class="uso-popup">
            <div class="uso-popup__dialog">
                <h4 class="h4">Location Notice</h4>
                <p>${msg}</p>
                <div class="uso-popup__actions">
                    <button id="uso-close" class="button button--secondary">
                    Continue browsing
                    </button>
                    <button id="uso-go" class="button">
                    Go to US Store
                    </button>
                </div>
            </div>
        </div>
    `;

    console.log('[USO] Popup HTML injected');

    document.body.appendChild(root);

    console.log('[USO] Popup appended to body');

    console.log('[USO] Current body:', document.body);

    const closeBtn = document.getElementById('uso-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        console.log('[USO] Close clicked');
        root.remove();
      });
    }
    const goBtn = document.getElementById('uso-go');
    if (goBtn) {
      goBtn.addEventListener('click', function () {
        console.log('[USO] Redirect clicked');
        window.location.href = REDIRECT_URL;
      });
    }

    console.log('[USO] Popup listeners attached');
  }
})();